import _ from "lodash"
import { subPartyAddApi } from "../../api/subParty/subPartyAddApi"

type PayloadShape = Parameters<typeof subPartyAddApi>[0]

export async function subPartyAddService(payload: PayloadShape, token: string) {
	if (_.isEmpty(payload.note)) payload.note = undefined
	return await subPartyAddApi(payload, token)
}
